<template>
  <div>
    <v-menu
      v-model="show"
      absolute
      :position-x="context.posX"
      :position-y="context.posY"
      offset-y
      :close-on-content-click="false"
      nudge-width="600"
    >
      <v-card max-height="700" class="allow_click">
        <v-card-text v-if="busy">
          <v-row>
            <v-col cols="5"></v-col>
            <v-col>
              <v-progress-circular indeterminate size="50" color="grey">
              </v-progress-circular>
            </v-col>
            <v-col cols="5"></v-col>
          </v-row>
        </v-card-text>
        <v-list dense v-else-if="documents.length">
          <v-list-item>
            <v-list-item-content>
              <v-row>
                <v-col cols="4"
                  ><span>{{ title }}</span></v-col
                >
                <v-col style="text-align: right">
                  <v-chip
                    v-if="context.hierarchySuggestions && context.hierarchySuggestions.show"
                    label
                    dark
                    color="green darken-2"
                    @click="compareDocDetailsFullSuggestions(documents)"
                    ><v-icon
                      :title="
                        context.hierarchySuggestions.hierarchyType.ht_name +
                        ' Categorisation'
                      "
                      >mdi-lightbulb-on</v-icon
                    ></v-chip
                  ><v-chip
                    label
                    class="ml-2"
                    dark
                    color="blue darken-2"
                    @click="compareDocDetailsFull(documents)"
                    ><v-icon title="Compare documents in full view" small
                      >mdi-content-duplicate</v-icon
                    ></v-chip
                  ><v-chip
                    v-if="showAttributeCompare"
                    label
                    class="ml-2"
                    color="blue darken-2"
                    dark
                    @click="$emit('editDocs', documents)"
                  >
                    <v-icon title="Show Details">mdi-view-week</v-icon></v-chip
                  ><v-chip
                    v-if="showTagCompare"
                    label
                    class="ml-2"
                    color="blue darken-2"
                    dark
                  @click="$emit('compareTags', documents)"
                  >
                  <v-icon title="Compare Tags">mdi-tag-multiple</v-icon></v-chip
                  ><v-chip
                    label
                    class="ml-2"
                    dark
                    color="blue darken-2"
                    :disabled="documents.length > 15"
                    @click="compareDocDetails(documents)"
                    ><v-icon title="Compare documents in Side-by-side view"
                      >mdi-compare</v-icon
                    ></v-chip
                  ><v-chip label class="ml-2" @click="show = false"
                    ><v-icon title="Close">mdi-close</v-icon></v-chip
                  ></v-col
                >
              </v-row>
            </v-list-item-content>
          </v-list-item>
          <v-list-item v-for="(d, di) in documents" :key="'doc' + di" :class="{ 'noperm': !d.hasPerm }">
            <v-list-item-title
              ><div class="allow_click "
              style="cursor: pointer"
              title="Click for document view"
              :disabled="!d.hasPerm"
              @click.stop="$emit('openDocumentSummary', $event, d)"><v-chip label outlined small class="caption"
                >{{ d.system_number }}</v-chip
              >
              {{ d.doc_name
              }}<DocStatus
                :doc_id="d.doc_id"
                sideAddendum
                xSmall
                style="margin-left: 10px"
              ></DocStatus></div></v-list-item-title
            ><v-list-item-action
              ><v-badge
                color="red"
                overlap
                v-if="d.matches_similar_content_same_name.length"
                :content="d.matches_similar_content_same_name.length"
              >
                <v-icon
                  color="teal"
                  title="click to compare docments with same title and similar content"
                  @click="
                    displayMatches(d, 'matches_similar_content_same_name')
                  "
                  >mdi-content-duplicate</v-icon
                >
              </v-badge></v-list-item-action
            ><v-list-item-action
              ><v-badge
                color="red"
                overlap
                v-if="d.matches_different_content_same_name.length"
                :content="d.matches_different_content_same_name.length"
              >
                <v-icon
                  color="indigo"
                  title="click to compare docments with same title but different content"
                  @click="
                    displayMatches(d, 'matches_different_content_same_name')
                  "
                  >mdi-content-duplicate</v-icon
                >
              </v-badge> </v-list-item-action
            ><v-list-item-action
              ><v-badge
                color="red"
                overlap
                v-if="d.matches_similar_content_different_name.length"
                :content="d.matches_similar_content_different_name.length"
              >
                <v-icon
                  color="blue"
                  title="click to compare docments with different title but similar content"
                  @click="
                    displayMatches(d, 'matches_similar_content_different_name')
                  "
                  >mdi-content-duplicate</v-icon
                >
              </v-badge>
            </v-list-item-action>
            <!-- <v-list-item-action v-if="context.showSuggestions"
              ><v-icon
                @click="suggestJobFamily"
                title="Click to see job family suggestions"
                >mdi-lightbulb-on</v-icon
              > </v-list-item-action
            > -->
            <v-list-item-action
              ><v-icon title="Document actions"
                class="ml-2"
                :disabled="!d.hasPerm"
                @click="openDocActionsMenuContext($event, d)"
                >mdi-dots-vertical</v-icon
              >
            </v-list-item-action>
            <v-list-item-action
              ><v-icon @click="removeFromList(d)" title="Remove Document from list">mdi-playlist-remove</v-icon>
            </v-list-item-action>
          </v-list-item>
        </v-list>
        <div v-else-if="matchSets.length">
          <v-list v-if="context.title"
            ><v-list-item
              ><h4>{{ context.title }}</h4></v-list-item
            ></v-list
          >
          <v-list v-for="(s, si) in matchSets" :key="'set' + si">
            <v-list-item
              ><v-list-item-title>{{ s.title }}</v-list-item-title>
              <v-list-item-action
                v-if="context.hierarchySuggestions && context.hierarchySuggestions.show"
                style="margin-left: 4px"
                ><v-chip
                  label
                  dark
                  color="green darken-2"
                  @click="compareDocDetailsFullSuggestions(s.documents)"
                  ><v-icon
                    :title="
                      context.hierarchySuggestions.hierarchyType.ht_name +
                      ' Categorisation'
                    "
                    >mdi-lightbulb-on</v-icon
                  ></v-chip
                ></v-list-item-action
              >
              <v-list-item-action style="margin-left: 4px"
                ><v-chip
                  label
                  dark
                  color="blue darken-2"
                  @click="compareDocDetailsFull(s.documents)"
                  ><v-icon title="Compare documents in full view"
                    >mdi-content-duplicate</v-icon
                  ></v-chip
                ></v-list-item-action
              >
              <v-list-item-action
                style="margin-left: 4px"
                v-if="showAttributeCompare"
                ><v-chip
                  label
                  color="blue darken-2"
                  dark
                  @click="$emit('editDocs', s.documents)"
                >
                  <v-icon title="Show Details">mdi-view-week</v-icon></v-chip
                ></v-list-item-action
              >
              <v-list-item-action
                style="margin-left: 4px"
                v-if="showTagCompare"
                ><v-chip
                  label
                  color="blue darken-2"
                  dark
                  @click="$emit('compareTags', s.documents)"
                >
                  <v-icon title="Compare Tags">mdi-tag-multiple</v-icon></v-chip
                ></v-list-item-action
              ><v-list-item-action style="margin-left: 4px"
                ><v-chip
                  label
                  dark
                  color="blue darken-2"
                  :disabled="s.documents.length > 15"
                  ><v-icon
                    @click="compareDocDetails(s.documents)"
                    title="Compare documents in Side-by-side view"
                    >mdi-compare</v-icon
                  ></v-chip
                ></v-list-item-action
              ></v-list-item
            >
            <v-list-item
              v-for="(d, di) in s.documents"
              :key="'set' + si + 'doc' + di"
              :class="{ 'noperm': !d.hasPerm }"
            >
              <v-list-item-icon v-if="percentColumn !== 'match_pct'"
                ><v-avatar
                  v-if="d[percentColumn]"
                  :color="
                    percentColumn === 'match_pct_content' ? 'teal' : 'indigo'
                  "
                  size="30"
                >
                  <span class="white--text" style="font-size: 12px">{{
                    Number.parseFloat(d[percentColumn]).toFixed() + "%"
                  }}</span>
                </v-avatar>
              </v-list-item-icon>
              <div v-else>
                <v-list-item-icon
                  ><v-avatar
                    v-if="d.match_pct_content"
                    color="teal"
                    size="30"
                    title="Similar content"
                  >
                    <span class="white--text" style="font-size: 12px">{{
                      Number.parseFloat(d.match_pct_content).toFixed() + "%"
                    }}</span>
                  </v-avatar>
                  <v-avatar
                    v-else-if="d.match_pct_name"
                    color="indigo"
                    size="30"
                    title="Same title different content"
                  >
                    <span class="white--text" style="font-size: 12px">{{
                      Number.parseFloat(d.match_pct_name).toFixed() + "%"
                    }}</span>
                  </v-avatar>
                </v-list-item-icon>
              </div>
              <v-tooltip bottom :disabled="d.hasPerm">
                <template v-slot:activator="{ on, attrs }">
                  <v-list-item-title
                    v-bind="attrs" v-on="on"
                    :disabled="!d.hasPerm"
                    @click="if (d.hasPerm) $emit('openDocument', d)"
                    style="cursor: pointer"
                    ><v-chip label outlined small
                      ><v-icon left small>mdi-file-document-edit-outline</v-icon
                      >{{ d.system_number }}</v-chip
                    >
                    {{ d.doc_name
                    }}<DocStatus
                      :doc_id="d.doc_id"
                      sideAddendum
                      xSmall
                      style="margin-left: 10px"
                    ></DocStatus
                  >
                  </v-list-item-title>
                  </template>
                <span>You do not have permission to access this document</span>
              </v-tooltip>
              <v-list-item-action
                ><v-icon :disabled="!d.hasPerm" @click="openDocActionsMenuContext($event, d)"
                  >mdi-dots-vertical</v-icon
                >
              </v-list-item-action>
            </v-list-item>
          </v-list>
        </div>
      </v-card>
    </v-menu>
    <DocumentCompare
      :show="fullCompareView.show"
      :title="'Document Comparison - ' + context.title"
      :compareList="fullCompareView.items"
      :highlightChanges="fullCompareView.highlightChanges"
      :hierarchySuggestions="fullCompareView.hierarchySuggestions"
      multiDoc
      showWorkflowActions
      @openDocument="$emit('openDocument', $event)"
      @copyDocument="$emit('copyDocument', $event)"
      @assignHierarchy="$emit('assignHierarchy', $event)"
      @close="fullCompareView.show = false"
    >
    </DocumentCompare>
    <v-dialog v-model="sideBySide.show" style="max-height: 93%;">
      <DocumentSideBySide
        v-if="sideBySide.show"
        :items="sideBySide.items"
        :isDialogue="true"
        @close="sideBySide.show = false"
        @openContext="openDocActionsMenuContext"
      ></DocumentSideBySide>
    </v-dialog>
    <DocActionsMenu
      :context="docActionsMenuContext"
      @openDocument="$emit('openDocument', docActionsMenuContext.document)"
      @copyDocument="$emit('copyDocument', docActionsMenuContext.document)"
    ></DocActionsMenu>
  </div>
</template>

<script>
import utils from "@/common/utils.js";
import DocStatus from "@/components/common/DocStatus";
import DocumentCompare from "@/components/document/DocumentCompare";
import DocumentSideBySide from "@/components/cDocumentSideBySide.vue";
import DocActionsMenu from "@/components/common/DocActionsMenu";

export default {
  name: "DocListMenu",
  props: {
    context: Object,
    showAttributeCompare: Boolean,
    showTagCompare: Boolean,
  },
  data: function () {
    return {
      utils: utils,
      documents: [],
      matchSets: [],
      title: null,
      show: false,
      busy: false,
      percentColumn: "match_pct_content",
      fullCompareView: {
        show: false,
        highlightChanges: false,
        hierarchySuggestions: { show: false, hierarchyType: null },
        items: [],
      },
      sideBySide: { show: false, items: [] },
      suggestions: { show: false, items: [] },
      docActionsMenuContext: {
        show: false,
        busy: false,
        document: null,
        posX: 0,
        posY: 0,
      },
    };
  },
  components: {
    DocStatus,
    DocumentCompare,
    DocumentSideBySide,
    DocActionsMenu,
  },
  watch: {
    // "context.documents": function (newVal) {
    //   if (newVal) this.init();
    // },
    "context.show": function (newVal) {
      if (newVal) this.init();
    },
  },
  mounted() {},
  created() {},
  computed: {},
  methods: {
    init() {
      //   this.document = this.$store.getters["docs/docsList"].find(
      //     (x) => x.doc_id === this.context.docs[0].doc_id
      //   );
      let matchSets = [];
      const allDocs = this.context.documents
          .map(d => ({
            ...d,
            hasPerm: !!this.$store.getters["docs/docsList"].find((x) => x.doc_id === d.doc_id)
          }));

      if (this.context.matchColumn) {
        let matchColumn = this.context.matchColumn;
        let mergeOnName = [
          "matches_similar_content_same_name",
          "matches_different_content_same_name",
        ].some((x) => x === matchColumn);

        allDocs
          .filter((d) => d[matchColumn].length)
          .forEach((d) => {
            let set = matchSets.find((s) =>
              s.docs.some(
                (x) =>
                  x.doc_id === d.doc_id ||
                  (mergeOnName &&
                    d[matchColumn].some((dm) =>
                      s.docs.some(
                        (sd) =>
                          sd.doc_id === dm.doc_id && sd.doc_name === dm.doc_name
                      )
                    ))
              )
            );
            if (!set) {
              set = {
                setNo: matchSets.length + 1,
                docs: [
                  {
                    doc_id: d.doc_id,
                    doc_name: d.doc_name,
                    doc_status: d.doc_status,
                    system_number: d.system_number,
                    hasPerm: d.hasPerm
                  },
                ],
              };
              matchSets.push(set);
            }
            d[matchColumn]
              .filter((dm) => !set.docs.some((x) => x.doc_id === dm.doc_id))
              .forEach((dm) => set.docs.push({
                ...dm,
                hasPerm: !!this.$store.getters["docs/docsList"].find((x) => x.doc_id === dm.doc_id)
              }));
          });
        matchSets = matchSets.map((s) => {
          return {
            title: `Match Set ${matchSets.length > 1 ? s.setNo : ""} - ${
              s.docs.length
            } ${
              matchColumn === "matches_different_content_same_name"
                ? "same titles"
                : "similar documents"
            } identified`,
            documents: s.docs,
            doc_ids: s.docs,
          };
        });
      }
      this.matchSets = matchSets;
      this.documents = matchSets.length ? [] : allDocs;
      this.setTitle();

      this.show = true;
    },
    setTitle() {
      this.title = `${this.documents.length} ${this.context.documentType}${
        this.documents.length > 1 ? "s" : ""
      }`;
    },
    compareDocDetailsFull(documents) {
      this.fullCompareView.show = true;
      this.fullCompareView.hierarchySuggestions.show = false;
      this.fullCompareView.items = documents;
    },
    compareDocDetailsFullSuggestions(documents) {
      this.fullCompareView.show = true;
      this.fullCompareView.hierarchySuggestions.show = true;
      this.fullCompareView.hierarchySuggestions.hierarchyType =
        this.context.hierarchySuggestions.hierarchyType;
      this.fullCompareView.items = documents;
    },
    compareDocDetails(items) {
      this.sideBySide.show = true;
      this.sideBySide.items = items || this.compareItems;
    },
    getSuggestions(items) {
      this.suggestions.show = true;
      this.suggestions.items = items || this.compareItems;
    },
    openDocActionsMenuContext(event, document) {
      event.preventDefault();
      if (document.isDocument) {
        this.docActionsMenuContext.document = this.getDocByRef(document.value);
      } else {
        this.docActionsMenuContext.document = this.getDocById(document.doc_id);
      }
      this.docActionsMenuContext.posX = event.clientX;
      this.docActionsMenuContext.posY = event.clientY;
      this.docActionsMenuContext.show = false;
      this.$nextTick(() => {
        this.docActionsMenuContext.show = true;
      });
    },
    displayMatches(document, matchType) {
      let docs = document[matchType];
      docs.unshift({ doc_id: document.doc_id });
      this.compareDocDetailsFull(docs);
    },
    getDocByRef(reference) {
      return this.$store.getters["docs/docsList"].find(
        (x) => x.system_number === reference
      );
    },
    getDocById(doc_id) {
      return this.$store.getters["docs/docsList"].find(
        (x) => x.doc_id === doc_id
      );
    },
    suggestJobFamily() {
      alert(
        "Suggestions from Tim's service soon will appear here for selection"
      );
    },
    removeFromList(doc) {
      let index = this.documents.findIndex((x) => x.doc_id === doc.doc_id);
      if (index >= 0) {
        this.documents.splice(index, 1);
        this.$emit("itemRemoved", doc);
        this.setTitle();
      }
      if (this.documents.length === 0) this.show = false;
    },
  },
};
</script>
<style scoped lang="scss">
.noperm {
  opacity: 0.6;
}
</style>